import React, { useState } from 'react';
import AdminSidebar from './components/AdminSidebar';
import Header from '../teacher_screen/components/Header';
import {
    Layout,
    Plus,
    Filter,
    MoreHorizontal,
    FileSpreadsheet,
    FileText,
    Award,
    Clock,
    User,
    ChevronDown,
    Search
} from 'lucide-react';

export default function Examinations() {
    const exams = [
        { id: 1, title: 'Final Term Examinations', sessions: '08 Sections', dates: 'Mar 15 - Mar 30', status: 'Upcoming' },
        { id: 2, title: 'Mid-Term Assessment', sessions: '12 Sections', dates: 'Oct 10 - Oct 25', status: 'Completed' },
        { id: 3, title: 'Scholarship Entrance Test', sessions: '02 Sections', dates: 'Apr 05, 2026', status: 'Scheduled' },
    ];

    return (
        <div className="flex h-screen bg-[#F8FAFC] overflow-hidden font-sans">
            <AdminSidebar />

            <main className="flex-1 overflow-y-auto px-8">
                <Header
                    title="Examination Board"
                    subtitle="Coordinate school-wide testing, grading systems and result publication"
                >
                    <button className="flex items-center gap-2 px-5 py-2.5 bg-[#111827] text-white rounded-xl text-[14px] font-bold shadow-lg shadow-gray-200 hover:bg-gray-800 transition-all uppercase tracking-tight">
                        <FileSpreadsheet size={18} />
                        Grading Rules
                    </button>

                    <button className="flex items-center gap-2 px-5 py-2.5 bg-blue-500 text-white rounded-xl text-[14px] font-bold shadow-lg shadow-blue-100 hover:bg-blue-600 transition-all">
                        <Plus size={18} />
                        Schedule Exam
                    </button>
                </Header>

                <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-10 overflow-hidden">
                    <div className="bg-white p-8 rounded-[32px] border border-gray-100 shadow-sm flex flex-col justify-between overflow-hidden relative group h-full min-h-[280px]">
                        <div className="absolute -right-8 -top-8 w-40 h-40 bg-blue-50 rounded-full group-hover:scale-110 transition-transform"></div>
                        <div className="relative z-10">
                            <span className="flex items-center gap-2 text-blue-500 font-black text-[12px] uppercase tracking-widest mb-6">
                                <Award size={18} /> Performance Metrics
                            </span>
                            <h3 className="text-[32px] font-black text-[#111827] mb-2 leading-tight">School Success Rate</h3>
                            <p className="text-gray-400 font-bold mb-8">Average GPA across all departments for current session</p>
                        </div>
                        <div className="relative z-10 flex items-center gap-8">
                            <div>
                                <h4 className="text-[42px] font-black text-[#111827]">92.4%</h4>
                                <p className="text-[11px] font-bold text-emerald-500 uppercase">+2.1% v/s Last Year</p>
                            </div>
                            <div className="h-12 w-px bg-gray-100"></div>
                            <div>
                                <h4 className="text-[42px] font-black text-[#111827]">3.8</h4>
                                <p className="text-[11px] font-bold text-gray-400 uppercase">Average GPA</p>
                            </div>
                        </div>
                    </div>

                    <div className="bg-white p-2 rounded-[32px] border border-gray-100 shadow-sm h-full flex flex-col overflow-hidden">
                        <div className="p-6 pb-2">
                            <h3 className="text-[18px] font-black text-[#111827] uppercase tracking-tight">Exam Calendar</h3>
                        </div>
                        <div className="flex-1 overflow-y-auto p-4 space-y-3">
                            {exams.map((ex) => (
                                <div key={ex.id} className="p-4 bg-slate-50/50 rounded-2xl border border-gray-50 flex items-center justify-between group hover:bg-blue-50/50 transition-all">
                                    <div className="flex items-center gap-4">
                                        <div className={`w-12 h-12 rounded-xl flex items-center justify-center font-black ${ex.status === 'Completed' ? 'bg-emerald-50 text-emerald-500' : 'bg-blue-50 text-blue-500'
                                            }`}>
                                            <FileText size={20} />
                                        </div>
                                        <div>
                                            <p className="text-[15px] font-black text-[#111827] group-hover:text-blue-600 transition-colors uppercase tracking-tight">{ex.title}</p>
                                            <div className="flex items-center gap-3 mt-0.5">
                                                <span className="text-[11px] font-bold text-gray-400 flex items-center gap-1.5"><Clock size={12} /> {ex.dates}</span>
                                                <span className="text-[11px] font-bold text-gray-400 flex items-center gap-1.5"><Layout size={12} /> {ex.sessions}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <span className={`px-3 py-1 rounded-lg text-[10px] font-black uppercase tracking-widest ${ex.status === 'Completed' ? 'bg-emerald-50 text-emerald-500' :
                                            ex.status === 'Upcoming' ? 'bg-amber-50 text-amber-500' : 'bg-blue-50 text-blue-500'
                                        }`}>
                                        {ex.status}
                                    </span>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>

                <div className="bg-white rounded-[32px] border border-gray-100 shadow-sm overflow-hidden flex flex-col mb-10">
                    <div className="p-8 flex items-center justify-between border-b border-gray-50 bg-[#F8FAFC]/50">
                        <h3 className="text-[20px] font-black text-[#111827]">Academic Results Feed</h3>
                        <div className="flex items-center gap-4">
                            <div className="relative group">
                                <Search size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
                                <input
                                    type="text"
                                    placeholder="Roll No or Name..."
                                    className="pl-9 pr-4 py-2 bg-white border border-gray-100 rounded-xl text-[13px] font-bold text-gray-700 w-48 focus:outline-none focus:ring-2 focus:ring-blue-100"
                                />
                            </div>
                            <button className="p-2 text-gray-400 hover:text-gray-900 border border-gray-100 rounded-lg bg-white"><Filter size={18} /></button>
                        </div>
                    </div>

                    <div className="p-8 flex flex-col items-center justify-center text-center space-y-4 py-24 opacity-50">
                        <div className="w-16 h-16 bg-slate-50 rounded-2xl flex items-center justify-center text-gray-300">
                            <FileSpreadsheet size={32} />
                        </div>
                        <div>
                            <p className="text-[16px] font-black text-gray-400 uppercase tracking-widest">No reports to display</p>
                            <p className="text-[13px] font-bold text-gray-300">New exam results will appear here once published</p>
                        </div>
                    </div>
                </div>
            </main>
        </div>
    );
}
